<template>
  <br>
  <div style="display: flex; justify-content: space-between; background-color: #f0f0f0; padding: 10px; border-radius: 5px;">
    <h4 style="margin: 0;">Paso 2: Por favor, revisa y acepta los términos y condiciones</h4>
    <h4 style="margin: 0;">
      <span class="badge bg-primary">&nbsp;</span>
      <span class="badge bg-primary">2</span>
      <span class="badge bg-primary">&nbsp;</span>
      <span class="badge bg-primary">&nbsp;</span>
      <span class="badge bg-primary">&nbsp;</span>
    </h4>
  </div>
  <hr>
  <div class="progress">
    <div class="progress-bar" role="progressbar" style="width: 40%" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"></div>
  </div>
  <br>
  <div class="container text-container">
    <form class="row g-3 needs-validation" novalidate>
      <div class="mb-3 text-area">
        <div class="form-control text-content" id="texto" readonly>
          <h1>Términos y Condiciones de Uso de [Nombre de la Aplicación]</h1>

<h2>Introducción</h2>
<p>
  Bienvenido a [nombre de la empresa], tu aliado en la gestión de atenciones médicas ambulatorias. Al acceder y utilizar nuestros servicios,
  confirmas tu aceptación de los siguientes términos y condiciones. Estos están diseñados para asegurar una operación eficiente y segura para todos
  nuestros usuarios. Si no estás de acuerdo con algún término aquí presente, por favor abstente de utilizar nuestros servicios.
</p>

<h2>Licencia de Uso</h2>
<p>
  Te otorgamos una licencia limitada, no exclusiva e intransferible para acceder y usar [Nombre de la Aplicación], exclusivamente para fines relacionados
  con la gestión y registro de atenciones médicas, respetando siempre las leyes de confidencialidad y privacidad de datos aplicables.
</p>

<h2>Restricciones de Uso</h2>
<ul>
  <li><strong>Uso Legal:</strong> La aplicación no debe ser utilizada para propósitos ilegales, ni para transmitir datos de salud sin el consentimiento
  explícito y conforme a la legislación aplicable.</li>
  <li><strong>Seguridad de Datos:</strong> Está prohibido intentar alterar, interceptar, o acceder sin autorización a cualquier dato dentro de la
  aplicación.</li>
  <li><strong>Integridad de la Aplicación:</strong> No debes descompilar, realizar ingeniería inversa, o desarmar cualquier aspecto de nuestra
  tecnología, ni intentar obtener el código fuente del software.</li>
</ul>

<h2>Uso Aceptable</h2>
<p>
  La aplicación está diseñada específicamente para gestionar atenciones médicas y debe ser utilizada únicamente para este propósito. Cualquier uso
  fraudulento, abusivo o contrario a estos términos puede resultar en la suspensión o terminación de tu acceso a nuestros servicios.
</p>

<h2>Confidencialidad y Privacidad de los Datos</h2>
<p>
  Nos comprometemos a proteger la privacidad y seguridad de los datos que nos confías. Consulta nuestra <a href="#">Política de Privacidad</a> para
  entender cómo recopilamos, usamos y protegemos tu información personal y los datos de salud.
</p>

<h2>Limitaciones de Responsabilidad</h2>
<p>
  [Nombre de la empresa] no será responsable por daños indirectos, especiales, incidentales o consecuentes que resulten del uso o la imposibilidad de usar
  nuestros servicios, incluso si hemos sido advertidos sobre la posibilidad de tales daños.
</p>

<h2>Modificaciones a los Términos</h2>
<p>
  Nos reservamos el derecho de modificar estos términos y condiciones en cualquier momento para adaptarlos a cambios legales o evoluciones en nuestros
  servicios. Es tu responsabilidad revisar estos términos regularmente. Tu uso continuado de [Nombre de la Aplicación] tras la publicación de cambios
  confirmará que aceptas dichas modificaciones.
</p>

<h2>Legislación Aplicable</h2>
<p>
  Estos términos se regirán e interpretarán según las leyes del Estado/País [Nombre del Estado/País], y cualquier disputa que surja bajo estos términos
  será resuelta exclusivamente en los tribunales de dicho estado o país.
</p>

<h2>Contacto</h2>
<p>
  Si tienes preguntas o preocupaciones sobre estos términos, no dudes en contactarnos a través de <a href="mailto:contacto@[nombredeempresa].com">contacto@[nombredeempresa].com</a>.
</p>
        </div>
      </div>
      <div class="col-12 d-flex justify-content-between align-items-center">
        <div>
          <input class="form-check-input" type="checkbox" value="" id="invalidCheck" required v-model="checked">
          <label class="form-check-label" for="invalidCheck">
            Acepto los términos y condiciones.
          </label>
          <div class="invalid-feedback">
            Debes aceptar los términos y condiciones para continuar.
          </div>
        </div>
        <button class="btn btn-primary" type="button" @click="aceptarTC()" :disabled="!checked">Continuar ></button>
      </div>
    </form>
  </div>
</template>

<script>
//import api from "@/services/api";
export default {
  data() {
    return {
      usuario: {},
      checked: false
    }
  },
  methods: {
    async aceptarTC() {
      //        await api.post('/usuarios', this.usuario)
      window.sessionStorage.setItem("registro_terminos", "SI");
      this.$router.push('Registro03Usuario')
    },
  },
}
</script>

<style src="@/assets/css/registro02TC.css" scoped></style>